export { default as AddCompany } from "./add-company.component";
export { default as DeleteCompany } from "./delete-company.component";